<template>
  <div>
    <div style="display: flex">
      <!-- <v-layout row wrap class="ma-0 pa-0">
        <v-flex xs7> -->
      <Multiselect
        @input="$emit('change', $event)"
        placeholder="Select category"
        v-model="selectedCategory"
        :options="categories"
        label="name"
      ></Multiselect>
      <!-- </v-flex>
        <v-flex xs2> -->
      <v-btn @click="showEditDialog = true" color="grey" icon outline
        ><v-icon color="grey">edit</v-icon></v-btn
      >
      <!-- </v-flex>
      </v-layout> -->
    </div>
    <div>
      <v-dialog v-model="showEditDialog" persistent width="550px">
        <v-card style="position: relative">
          <div class="py-2 pl-2">
            <div style="font-size: 20px; font-weight: 600">Edit category</div>
            <div style="position: absolute; right: 0px; top: 0px" class="text-xs-right">
              <v-btn @click="showEditDialog = false" icon> <v-icon>close</v-icon></v-btn>
            </div>
          </div>
          <v-divider></v-divider>
          <div class="px-3 py-3">
            <div>
              <div
                v-if="!isCreate"
                @click="isCreate = true"
                class="category-item-add pa-2 text-xs-center mb-3"
              >
                Create category
              </div>
              <div v-else>
                <div
                  xs12
                  sm6
                  class="form-control pa-1 category-item mb-3"
                  :class="{ 'has-error': errors.has('ชื่อ Category') }"
                >
                  <input
                    placeholder="กรอกชื่อ Category"
                    :data-vv-as="$t('ชื่อ Category')"
                    v-validate="'required'"
                    name="ชื่อ Category"
                    v-model="input.name"
                    class="form-control"
                    type="text"
                  />
                  <span class="text-error" v-if="errors.has('ชื่อ Category')">{{
                    errors.first('ชื่อ Category')
                  }}</span>
                  <div class="text-xs-center">
                    <v-btn @click="cancelCreate" color="grey" outline>cancel</v-btn>
                    <v-btn @click="saveCreate" :loading="createLoading" depressed color="primary"
                      >Save</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>

            <div v-for="(cat, k) in categories" :key="cat.id" class="category-item pa-2 mb-2">
              <v-layout v-if="!isShowEdit(cat.id)" row wrap class="pa-0 ma-0">
                <v-flex xs12 style="position: relative">
                  <div>{{ cat.name }}</div>
                  <div style="position: absolute; right: 0px; top: -3px">
                    <v-btn @click="showEditItems.push({ ...cat })" small icon class="ma-0">
                      <v-icon color="#8b8b8b" small>edit</v-icon>
                    </v-btn>
                    <v-btn @click="deleteCategory(cat)" icon small class="ma-0">
                      <v-icon color="#8b8b8b" small>delete</v-icon>
                    </v-btn>
                  </div>
                </v-flex>
              </v-layout>
              <div v-else>
                <div
                  xs12
                  sm6
                  class="form-control pa-1"
                  :class="{ 'has-error': errors.has('ชื่อ Category') }"
                >
                  <input
                    placeholder="กรอกชื่อ Category"
                    :data-vv-as="$t('ชื่อ Category')"
                    v-validate="'required'"
                    name="ชื่อ Category"
                    v-model="categories[k].name"
                    class="form-control"
                    type="text"
                  />
                  <span class="text-error" v-if="errors.has('ชื่อ Category')">{{
                    errors.first('ชื่อ Category')
                  }}</span>
                  <div class="text-xs-center">
                    <v-btn @click="cancelEdit(cat)" color="grey" outline>cancel</v-btn>
                    <v-btn
                      :loading="isEditLoading(cat.id)"
                      @click="saveEdit(cat)"
                      depressed
                      color="primary"
                      >Save</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import api from '@/api'
import { mapGetters } from 'vuex'
export default {
  components: {
    Multiselect
  },
  computed: {
    ...mapGetters(['selectedBot']),
    categories: {
      get() {
        return this.$store.state.toacrmrewardcategories
      },
      set(val) {
        this.$store.state.toacrmrewardcategories = val
      }
    }
  },
  data() {
    return {
      showEditItems: [],
      editloading: [],
      createLoading: false,
      showEditDialog: false,
      isCreate: false,
      input: {
        name: ''
      },

      selectedCategory: ''
    }
  },
  mounted() {
    this.getCategory()
  },
  methods: {
    getCategory() {
      var data = {
        pageid: this.selectedBot.pageid
      }
      api.getrewardcategorytoacrm(data, (err, response) => {
        if (response.responsecode == 200) {
          this.categories = response.data
        }
      })
    },
    deleteCategory(cat) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            var data = {
              pageid: this.selectedBot.pageid,
              id: cat.id
            }
            var index = this.categories.findIndex((el) => el.id == cat.id)
            api.deleterewardcategorytoacrm(data, (err, response) => {
              if (response.responsecode == 200) {
                this.categories.splice(index, 1)
              }
            })
          }
        })
    },
    isEditLoading(id) {
      return this.editloading.some((el) => el.id == id)
    },
    saveEdit(cat) {
      var catindex = this.categories.findIndex((el) => el.id == cat.id)
      this.editloading.push(cat)
      var editloadingindex = this.editloading.findIndex((el) => el.id == cat.id)
      var data = {
        pageid: this.selectedBot.pageid,
        id: cat.id,
        name: cat.name
      }

      api.editrewardcategorytoacrm(data, (err, response) => {
        this.editloading.splice(editloadingindex, 1)
        if (response.responsecode == 200) {
          var showindex = this.showEditItems.findIndex((el) => el.id == cat.id)
          this.showEditItems.splice(showindex, 1)
        }
      })
    },
    cancelEdit(cat) {
      var showindex = this.showEditItems.findIndex((el) => el.id == cat.id)
      var catindex = this.categories.findIndex((el) => el.id == cat.id)
      this.categories[catindex] = this.showEditItems[showindex]
      this.showEditItems.splice(showindex, 1)
    },
    isShowEdit(id) {
      return this.showEditItems.some((el) => el.id == id)
    },
    cancelCreate() {
      this.isCreate = false
      this.input.name = ''
    },
    async saveCreate() {
      this.createLoading = true
      if (await this.$validator.validateAll()) {
        var data = {
          pageid: this.selectedBot.pageid,
          name: this.input.name
        }
        api.creatrewardcategorytoacrm(data, (err, response) => {
          this.createLoading = false
          if (response.responsecode == 200) {
            this.categories.unshift(response.data[0])
            this.cancelCreate()
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
.category-item {
  position: relative !important;
  border: 1px solid darkgrey !important;
  border-radius: 8px !important;
  background-color: #f4f4f4 !important;
}
.category-item-add {
  position: relative;
  border: 3px dashed #cbcbcb;
  border-radius: 8px;

  color: #b8b8b8;
  font-weight: 600;
  font-size: 22px;
  cursor: pointer;
}
.category-item-add:hover {
  border: 3px dashed rgb(44, 44, 44) !important;
  color: rgb(44, 44, 44);
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/RewardCategory.vue